module.exports = __webpack_public_path__ + "img/warning.b0a971cb.svg";